import { siteApiSlice } from "../../app/siteApiSlice";

export interface ManageReviewGroupsPageViewModel {
	groupsPage: ManageReviewGroupRow[];
	writerPool: ReviewGroupWriterModel[];
	courseHasStudents: boolean;
	canRandomizeGroups: boolean;
}

export interface ManageReviewGroupRow {
	id: number;
	name: string;
	studentNames: string;
}

export interface EditReviewGroupModel {
	id: number;
	name: string;
	writerIds: number[];
	writerPool: ReviewGroupWriterModel[];
}

export interface ReviewGroupWriterModel {
	id: number;
	fullName: string;
}

export const peerReviewGroupsApiSlice = siteApiSlice
	.enhanceEndpoints({
		addTagTypes: ["PeerReviewGroup"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			manageReviewGroupsPage: build.query<ManageReviewGroupsPageViewModel, void>({
				query: () => ({
					url: `/PeerReviewGroup/ManageGroups`,
					method: "GET",
				}),
				providesTags: ["PeerReviewGroup", "CurrentCourse"],
			}),
			randomizeGroups: build.mutation<void, { minSize: number }>({
				query: (payload) => ({
					url: `/PeerReviewGroup/RandomizeGroups`,
					method: "POST",
					body: payload,
				}),
				invalidatesTags: ["PeerReviewGroup"],
			}),
			addGroupInfo: build.query<EditReviewGroupModel, void>({
				query: () => ({
					url: `/PeerReviewGroup/AddNewGroup`,
					method: "GET",
				}),
				providesTags: ["PeerReviewGroup"],
			}),
			addGroup: build.mutation<void, EditReviewGroupModel>({
				query: (payload) => ({
					url: `/PeerReviewGroup/AddNewGroup`,
					method: "POST",
					body: payload,
				}),
				invalidatesTags: ["PeerReviewGroup"],
			}),
			editGroupInfo: build.query<EditReviewGroupModel, string | number>({
				query: (id) => ({
					url: `/PeerReviewGroup/EditExistingGroup`,
					method: "GET",
					params: { id },
				}),
				providesTags: ["PeerReviewGroup"],
			}),
			editGroup: build.mutation<void, EditReviewGroupModel>({
				query: (payload) => ({
					url: `/PeerReviewGroup/EditExistingGroup`,
					method: "POST",
					body: payload,
				}),
				invalidatesTags: ["PeerReviewGroup"],
			}),
			removeGroup: build.mutation<string | undefined, { id: number }>({
				query: (payload) => ({
					url: `/PeerReviewGroup/RemoveGroup`,
					method: "POST",
					body: payload,
				}),
				invalidatesTags: ["PeerReviewGroup"],
			}),
		}),
	});

export const {
	useManageReviewGroupsPageQuery,
	useRandomizeGroupsMutation,
	useAddGroupInfoQuery: useAddGroupQuery,
	useLazyAddGroupInfoQuery: useLazyAddGroupQuery,
	useAddGroupMutation,
	useEditGroupInfoQuery: useEditGroupQuery,
	useLazyEditGroupInfoQuery: useLazyEditGroupQuery,
	useEditGroupMutation,
	useRemoveGroupMutation,
} = peerReviewGroupsApiSlice;
